// removed by extract-text-webpack-plugin
module.exports = {"filterToggle":"filtersHeaderToggle__filterToggle--3Gmeu","selected":"filtersHeaderToggle__selected--1WYfu","unselected":"filtersHeaderToggle__unselected--3cNg7","labelText":"filtersHeaderToggle__labelText--3yvsY","filterToggleIcon":"filtersHeaderToggle__filterToggleIcon--3mPz5"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/FilterComponents/filtersHeaderToggle.css
// module id = 8rU9
// module chunks = 22